import { UserStudy } from '@models/userStudy.model';

export class User {
  userId: number;
  emailAddress: string;
  firstName: string;
  lastName: string;
  middleName: string;
  preferredName: string;
  rank: string;
  officeLocationId?: number;
  isSuperUser: boolean;
  profilePicture: string;
  activeDirectoryId: string;
  userPrincipalName: string;
  jobTitle: string;
  officeLocation: string;
  samAccount: string;
  isActive: boolean;
  isFirstTimeUser: boolean;
  userStudy: UserStudy[];
  CountryName: string;
}
